export class CreateCaseFiltersSelection {
    jurisdictionId: string;
    caseTypeId: string;
    eventId: string;

    constructor() {
        this.jurisdictionId = 'TEST',
        this.caseTypeId = 'TestAddressBookCase',
        this.eventId = 'startCase'
    }
}
